// eslint-disable-next-line eag/match-named-export
import i18n from 'i18next';

export type OmneticReleaseNote = {
  type: 'feature' | 'bugfix';
  url: string;
  title: string;
  dateTime: string;
  description: string;
  featureName?: string;
  countryCodesAlpha3?: string[];
  // TODO: This should be probably handled by Doc360.
  urlByCountry?: {
    [key: string]: string;
  };
  versionNumber?: string;
};

export const omneticReleaseNotes: OmneticReleaseNote[] = [
  {
    type: 'feature',
    title: i18n.t('release_09-2026-title'),
    description: i18n.t('release_09-2026-description'),
    dateTime: '28.4.2026',
    url: '/docs/news-2026-09',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2026-09',
      POL: '/docs/pl/news-2026-09',
    },
    versionNumber: '1.99',
  },
  {
    type: 'feature',
    title: i18n.t('release_08-2026-title'),
    description: i18n.t('release_08-2026-description'),
    dateTime: '14.4.2026',
    url: '/docs/news-2026-08',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2026-08',
      POL: '/docs/pl/news-2026-08',
    },
    versionNumber: '1.98',
  },
  {
    type: 'feature',
    title: i18n.t('release_07-2026-title'),
    description: i18n.t('release_07-2026-description'),
    dateTime: '31.3.2026',
    url: '/docs/news-2026-07',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2026-07',
      POL: '/docs/pl/news-2026-07',
    },
    versionNumber: '1.97',
  },
  {
    type: 'feature',
    title: i18n.t('release_06-2026-title'),
    description: i18n.t('release_06-2026-description'),
    dateTime: '17.3.2026',
    url: '/docs/news-2026-06',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2026-06',
      POL: '/docs/pl/news-2026-06',
    },
    versionNumber: '1.96',
  },
  {
    type: 'feature',
    title: i18n.t('release_05-2026-title'),
    description: i18n.t('release_05-2026-description'),
    dateTime: '3.3.2026',
    url: '/docs/news-2026-05',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2026-05',
      POL: '/docs/pl/news-2026-05',
    },
    versionNumber: '1.95',
  },
  {
    type: 'feature',
    title: i18n.t('release_04-2026-title'),
    description: i18n.t('release_04-2026-description'),
    dateTime: '17.2.2026',
    url: '/docs/news-2026-04',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2026-04',
      POL: '/docs/pl/news-2026-04',
    },
    versionNumber: '1.94',
  },
  {
    type: 'feature',
    title: i18n.t('release_03-2026-title'),
    description: i18n.t('release_03-2026-description'),
    dateTime: '4.2.2026',
    url: '/docs/news-2026-03',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2026-03',
      POL: '/docs/pl/news-2026-03',
    },
    versionNumber: '1.93',
  },
  {
    type: 'feature',
    title: i18n.t('release_02-2026-title'),
    description: i18n.t('release_02-2026-description'),
    dateTime: '20.1.2026',
    url: '/docs/news-2026-02',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2026-02',
      POL: '/docs/pl/news-2026-02',
    },
    versionNumber: '1.92',
  },
  {
    type: 'feature',
    title: i18n.t('release_01-2026-title'),
    description: i18n.t('release_01-2026-description'),
    dateTime: '6.1.2026',
    url: '/docs/news-2026-01',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2026-01',
      POL: '/docs/pl/news-2026-01',
    },
    versionNumber: '1.91',
  },
  {
    type: 'feature',
    title: i18n.t('release_24-2025-title'),
    description: i18n.t('release_24-2025-description'),
    dateTime: '16.12.2025',
    url: '/docs/news-2025-24',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-24',
      POL: '/docs/pl/news-2025-24',
    },
    versionNumber: '1.90',
  },
  {
    type: 'feature',
    title: i18n.t('release_23-2025-title'),
    description: i18n.t('release_23-2025-description'),
    dateTime: '2.12.2025',
    url: '/docs/news-2025-23',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-23',
      POL: '/docs/pl/news-2025-23',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_22-2025-title'),
    description: i18n.t('release_22-2025-description'),
    dateTime: '19.11.2025',
    url: '/docs/news-2025-22',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-22',
      POL: '/docs/pl/news-2025-22',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_21-2025-title'),
    description: i18n.t('release_21-2025-description'),
    dateTime: '21.10.2025',
    url: '/docs/news-2025-21',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-21',
      POL: '/docs/pl/news-2025-21',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_20-2025-title'),
    description: i18n.t('release_20-2025-description'),
    dateTime: '7.10.2025',
    url: '/docs/news-2025-20',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-20',
      POL: '/docs/pl/news-2025-20',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_19-2025-title'),
    description: i18n.t('release_19-2025-description'),
    dateTime: '25.9.2025',
    url: '/docs/news-2025-19',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-19',
      POL: '/docs/pl/news-2025-19',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_18-2025-title'),
    description: i18n.t('release_18-2025-description'),
    dateTime: '10.9.2025',
    url: '/docs/news-2025-18',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-18',
      POL: '/docs/pl/news-2025-18',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_17-2025-title'),
    description: i18n.t('release_17-2025-description'),
    dateTime: '10.9.2025',
    url: '/docs/news-2025-17',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-17',
      POL: '/docs/pl/news-2025-17',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_16-2025-title'),
    description: i18n.t('release_16-2025-description'),
    dateTime: '12.8.2025',
    url: '/docs/news-2025-16',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-16',
      POL: '/docs/pl/news-2025-16',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_15-2025-title'),
    description: i18n.t('release_15-2025-description'),
    dateTime: '29.7.2025',
    url: '/docs/news-2025-15',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-15',
      POL: '/docs/pl/news-2025-15',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_14-2025-title'),
    description: i18n.t('release_14-2025-description'),
    dateTime: '15.7.2025',
    url: '/docs/news-2025-14',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-14',
      POL: '/docs/pl/news-2025-14',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_13-2025-title'),
    description: i18n.t('release_13-2025-description'),
    dateTime: '1.7.2025',
    url: '/docs/news-2025-13',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-13',
      POL: '/docs/pl/news-2025-13',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_12-2025-title'),
    description: i18n.t('release_12-2025-description'),
    dateTime: '17.6.2025',
    url: '/docs/news-2025-12',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-12',
      POL: '/docs/pl/news-2025-12',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_11-2025-title'),
    description: i18n.t('release_11-2025-description'),
    dateTime: '3.6.2025',
    url: '/docs/news-2025-11',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-11',
      POL: '/docs/pl/news-2025-11',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_10-2025-title'),
    description: i18n.t('release_10-2025-description'),
    dateTime: '20.5.2025',
    url: '/docs/news-2025-10',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-10',
      POL: '/docs/pl/news-2025-10',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_09-2025-title'),
    description: i18n.t('release_09-2025-description'),
    dateTime: '6.5.2025',
    url: '/docs/news-2025-09',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-09',
      POL: '/docs/pl/news-2025-09',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_08-2025-title'),
    description: i18n.t('release_08-2025-description'),
    dateTime: '22.4.2025',
    url: '/docs/news-2025-08',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-08',
      POL: '/docs/pl/news-2025-08',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_07-2025-title'),
    description: i18n.t('release_07-2025-description'),
    dateTime: '8.4.2025',
    url: '/docs/news-2025-07',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-07',
      POL: '/docs/pl/news-2025-07',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_06-2025-title'),
    description: i18n.t('release_06-2025-description'),
    dateTime: '25.3.2025',
    url: '/docs/news-2025-06',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-06',
      POL: '/docs/pl/news-2025-06',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_05-2025-title'),
    description: i18n.t('release_05-2025-description'),
    dateTime: '11.3.2025',
    url: '/docs/news-2025-05',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-05',
      POL: '/docs/pl/news-2025-05',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_04-2025-title'),
    description: i18n.t('release_04-2025-description'),
    dateTime: '25.2.2025',
    url: '/docs/news-2025-04',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-04',
      POL: '/docs/pl/news-2025-04',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_03-2025-title'),
    description: i18n.t('release_03-2025-description'),
    dateTime: '11.2.2025',
    url: '/docs/news-2025-03',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-03',
      POL: '/docs/pl/news-2025-03',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_02-2025-title'),
    description: i18n.t('release_02-2025-description'),
    dateTime: '28.1.2025',
    url: '/docs/news-2025-02',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-02',
      POL: '/docs/pl/news-2025-02',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_01-2025-title'),
    description: i18n.t('release_01-2025-description'),
    dateTime: '14.1.2025',
    url: '/docs/news-2025-01',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2025-01',
      POL: '/docs/pl/news-2025-01',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_20-2024-title'),
    description: i18n.t('release_20-2024-description'),
    dateTime: '17.12.2024',
    url: '/docs/news-2024-20',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2024-20',
      POL: '/docs/pl/news-2024-20',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_19-2024-title'),
    description: i18n.t('release_19-2024-description'),
    dateTime: '3.12.2024',
    url: '/docs/news-2024-19',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2024-19',
      POL: '/docs/pl/news-2024-19',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_18-2024-title'),
    description: i18n.t('release_18-2024-description'),
    dateTime: '22.11.2024',
    url: '/docs/news-2024-18',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2024-18',
      POL: '/docs/pl/news-2024-18',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_16-2024-title'),
    description: i18n.t('release_16-2024-description'),
    dateTime: '5.11.2024',
    url: '/docs/news-2024-17',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2024-17',
      POL: '/docs/pl/news-2024-17',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_15-2024-title'),
    description: i18n.t('release_15-2024-description'),
    dateTime: '22.10.2024',
    url: '/docs/news-2024-15',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2024-15',
      POL: '/docs/pl/news-2024-15',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_14-2024-title'),
    description: i18n.t('release_14-2024-description'),
    dateTime: '8.10.2024',
    url: '/docs/news-2024-14-2',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2024-14-2',
      POL: '/docs/pl/news-2024-14-2',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_13-2024-title'),
    description: i18n.t('release_13-2024-description'),
    dateTime: '24.9.2024',
    url: '/docs/news-2024-13',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2024-13',
      POL: '/docs/pl/news-2024-13',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_12-2024-title'),
    description: i18n.t('release_12-2024-description'),
    dateTime: '10.9.2024',
    url: '/docs/news-2024-12',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2024-12',
      POL: '/docs/pl/news-2024-12',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_11-2024-title'),
    description: i18n.t('release_11-2024-description'),
    dateTime: '27.8.2024',
    url: '/docs/news-2024-11',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2024-10',
      POL: '/docs/pl/news-2024-10',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_10-2024-title'),
    description: i18n.t('release_10-2024-description'),
    dateTime: '13.8.2024',
    url: '/docs/news-2024-10',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2024-10',
      POL: '/docs/pl/news-2024-10',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_09-2024-title'),
    description: i18n.t('release_09-2024-description'),
    dateTime: '30.7.2024',
    url: '/docs/news-2024-09',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2024-09',
      POL: '/docs/pl/news-2024-09',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_08-2024-title'),
    description: i18n.t('release_08-2024-description'),
    dateTime: '16.7.2024',
    url: '/docs/news-2024-08',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2024-08',
      POL: '/docs/pl/news-2024-08',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_07-2024-title'),
    description: i18n.t('release_07-2024-description'),
    dateTime: '2.7.2024',
    url: '/docs/news-2024-07',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2024-07',
      POL: '/docs/pl/news-2024-07',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_06-2024-title'),
    description: i18n.t('release_06-2024-description'),
    dateTime: '18.6.2024',
    url: '/docs/news-2024-06',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2024-06',
      POL: '/docs/pl/news-2024-06',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_05-2024-title'),
    description: i18n.t('release_05-2024-description'),
    dateTime: '4.6.2024',
    url: '/docs/news-2024-05',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2024-05',
      POL: '/docs/pl/news-2024-05',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_04-2024-title'),
    description: i18n.t('release_04-2024-description'),
    dateTime: '12.5.2024',
    url: '/docs/news-2024-04',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/news-2024-04',
      POL: '/docs/pl/news-2024-04',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_03-2024-title'),
    description: i18n.t('release_03-2024-description'),
    dateTime: '6.4.2024',
    url: '/docs/news-2024-03',
    countryCodesAlpha3: ['CZE'],
  },
  {
    type: 'feature',
    title: i18n.t('release_02-2024-title'),
    description: i18n.t('release_02-2024-description'),
    dateTime: '25.3.2024',
    url: '/docs/novinky-2024-02',
    countryCodesAlpha3: ['CZE'],
  },
  {
    type: 'feature',
    title: i18n.t('release_01-2024-title'),
    description: i18n.t('release_01-2024-description'),
    dateTime: '5.2.2024',
    url: '/docs/novinky-2024-01',
    featureName: 'release_01-2024',
    countryCodesAlpha3: ['CZE', 'POL'],
    urlByCountry: {
      CZE: '/docs/novinky-2024-01',
      POL: '/docs/pl/news-omnetic-2024-01',
    },
  },
  {
    type: 'feature',
    title: i18n.t('release_09-2023-title'),
    description: i18n.t('release_09-2023-description'),
    dateTime: '22.12.2023',
    url: '/docs/novinky-2023-09',
    countryCodesAlpha3: ['CZE'],
  },
  {
    type: 'feature',
    title: i18n.t('release_08-2023-title'),
    description: i18n.t('release_08-2023-description'),
    dateTime: '4.12.2023',
    url: '/docs/novinky-2023-08',
    countryCodesAlpha3: ['CZE'],
  },
  {
    type: 'feature',
    title: i18n.t('release_07-2023-title'),
    description: i18n.t('release_07-2023-description'),
    dateTime: '6.11.2023',
    url: '/docs/novinky-2023-07',
    countryCodesAlpha3: ['CZE'],
  },
  {
    type: 'feature',
    title: i18n.t('release_06-2023-title'),
    description: i18n.t('release_06-2023-description'),
    dateTime: '4.9.2023',
    url: '/docs/novinky-2023-06',
    countryCodesAlpha3: ['CZE'],
  },
  {
    type: 'feature',
    title: i18n.t('release_05-2023-title'),
    description: i18n.t('release_05-2023-description'),
    dateTime: '7.7.2023',
    url: '/docs/novinky-2023-05',
    countryCodesAlpha3: ['CZE'],
  },
  {
    type: 'feature',
    title: i18n.t('release_04-2023-title'),
    description: i18n.t('release_04-2023-description'),
    dateTime: '12.5.2023',
    url: '/docs/novinky-2023-04',
    countryCodesAlpha3: ['CZE'],
  },
  {
    type: 'feature',
    title: i18n.t('release_03-2023-title'),
    description: i18n.t('release_03-2023-description'),
    dateTime: '4.4.2023',
    url: '/docs/novinky-2023-03',
    countryCodesAlpha3: ['CZE'],
  },
  {
    type: 'feature',
    title: i18n.t('release_02-2023-title'),
    description: i18n.t('release_02-2023-description'),
    dateTime: '16.3.2023',
    url: '/docs/novinky-2023-02',
    countryCodesAlpha3: ['CZE'],
  },
  {
    type: 'feature',
    title: i18n.t('release_01-2023-title'),
    description: i18n.t('release_01-2023-description'),
    dateTime: '6.2.2023',
    url: '/docs/novinky-2023-01',
    countryCodesAlpha3: ['CZE'],
  },
  {
    type: 'feature',
    title: i18n.t('release_06-2022-title'),
    description: i18n.t('release_06-2022-description'),
    dateTime: '2.12.2022',
    url: '/docs/novinky-06-2022',
    countryCodesAlpha3: ['CZE'],
  },
  {
    type: 'feature',
    title: i18n.t('release_05-2022-title'),
    description: i18n.t('release_05-2022-description'),
    dateTime: '26.10.2022',
    url: '/docs/novinky-05-2022',
    countryCodesAlpha3: ['CZE'],
  },
  {
    type: 'feature',
    title: i18n.t('release_04-2022-title'),
    description: i18n.t('release_04-2022-description'),
    dateTime: '9.9.2022',
    url: '/docs/novinky-od-11-8-2022',
    countryCodesAlpha3: ['CZE'],
  },
  {
    type: 'feature',
    title: i18n.t('release_03-2022-title'),
    description: i18n.t('release_03-2022-description'),
    dateTime: '28.7.2022',
    url: '/docs/novinky-od-28-7-2022',
    countryCodesAlpha3: ['CZE'],
  },
  {
    type: 'feature',
    title: i18n.t('release_02-2022-title'),
    description: i18n.t('release_02-2022-description'),
    dateTime: '1.7.2022',
    url: '/docs/novinky-od-01-07-2022',
    countryCodesAlpha3: ['CZE'],
  },
  {
    type: 'feature',
    title: i18n.t('release_01-2022-title'),
    description: i18n.t('release_01-2022-description'),
    dateTime: '15.6.2022',
    url: '/docs/novinky-od-162022',
    countryCodesAlpha3: ['CZE'],
  },
];
